const logo = "<Isaac dev/>"

export const NavBar = () => {
    return (
        <>
            {/* canto esquerdo */}
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container">
                    <a className="navbar-brand" href="#">
                        <h2 className="logo">{logo} </h2>
                    </a>
                    <button 
                    className="navbar-toggler" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#navbarNav" 
                    aria-controls="navbarNav" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation"
                    >
                    <span className="navbar-toggler-icon"></span>
                    </button>

                    {/* Canto direito */}
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            <li><a className='nav-link' href="#apresentacao">Apresentação</a></li>
                            <li><a className='nav-link' href="#sobre">Sobre</a></li>
                            <li><a className='nav-link' href="#projetos">Projetos</a></li>
                            <li><a className='nav-link' href="#contato">Contato</a></li>
                            <li className="nav-item">
                                <a className="nav-link active btn btn-dark text-white" aria-current="page"  href="https://wa.me/27996908012" target="_blank" >Fale comigo</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

        </>
    );
}


